import { Filter } from '@anytag/shared-molecules';
import { BasicFilter } from './BasicFilter';
import { useEngagementCampaignsFilter } from './hooks';

export const EngagementCampaignsFilter = () => {
  const { filter, setFilterForm } = useEngagementCampaignsFilter();

  return (
    <Filter.Provider values={filter} onSubmit={setFilterForm} className="rounded-none">
      <BasicFilter />
    </Filter.Provider>
  );
};
export { useEngagementCampaignsFilter };
export * from './schemaTypes';
